import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { IconRegistryService } from '../services/m-icon-registry.service';

export function provideMIcons(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const http = inject(IconRegistryService);
    return http.loadIcons();
  });
}
